'use strict';

import React from 'react';
import get from 'lodash/get';
import Notification from '../../Notification';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { OTLink } from '../../tag/OTLink';
import {
  formatCustom,
  formatDate,
  formatTime,
  getTime,
} from '../../../utils/TimeUtils';
import { getDepartmentDisplay } from '../../../utils/TimelineUtils';
import Loader from '../../Loader';
import OTIcon from '../../tag/OTIcon';
import OTButton from '../../tag/OTButton';
import { doRequestDismissNotifications } from '../../../data/notification/actions';
import { QUESTIONNAIRE_PAGE_NOTIFICATION } from '../../../definitions/NotificationConstants';
import WindowUtils from '../../../utils/WindowUtils';
import OTButtonGroup from '../../tag/OTButtonGroup';
import Row from '../../tag/Row';
import Span from '../../tag/Span';
import { getLogo } from '../../../utils/LogoUtils';

const { id: module_id } = module;

class CareRequestNotification extends React.Component {
  render() {
    let {
      data,
      showActiveQuestionnaireDescription,
      doRequestDismissNotifications,
      intl,
    } = this.props;

    let { appointmentData } = data;

    let endDateTime = get(data, 'endDateTime', null) ? (
      <span className="ot-notification__date">
        <FormattedMessage
          id={`${module_id}.fill.at.the.latest`}
          values={{
            date: getTime(data.endDateTime).format('DD.MM.YYYY'),
          }}
        />
      </span>
    ) : null;

    let description,
      unitLogo = null;

    // Default Heading message
    let headerMessage = (
      <FormattedMessage id={`${module_id}.new.questionnaire`} />
    );
    // Default Info text
    let info = <FormattedMessage id={`${module_id}.info.questionnaire`} />;
    // Default button texts
    let otButtonTextNow = <FormattedMessage id={`fill`} />;
    let otButtonTextLater = <FormattedMessage id={`fill.later`} />;

    if (data.category === 'sydansairaala') {
      let logoAttr = getLogo('SYDAN');
      unitLogo = (
        <img
          alt={intl.formatMessage({ id: logoAttr.altTextId })}
          src={logoAttr.logoSrc}
          style={{
            float: 'right',
            maxWidth: '120px',
            maxHeight: '26px',
            paddingTop: '7px',
          }}
        />
      );
    }
    if (!showActiveQuestionnaireDescription) {
      description = <Loader style={{ margin: '40px auto' }} />;
    } else if (
      //KORONAPOTILAAN OMAISEN SUOSTUMUS
      data.category === 'suostumus-omainen'
    ) {
      description = (
        <FormattedMessage
          id={`${module_id}.fill.name.only`}
          values={{
            name: data.name,
            strong: (chunks) => <strong>{chunks}</strong>,
          }}
        />
      );
      return (
        <Notification>
          <OTIcon
            config={{ type: 'custom', name: 'kyselyt', color: 'darkblue' }}
            style={{ width: '17px', marginRight: '20px' }}
          />
          <h2 className="ot-notification__header">
            <FormattedMessage id={`${module_id}.header`} />
          </h2>
          <div className="ot-notification__description">{description}</div>
          {data.description && (
            <div className="ot-notification__description">
              <OTIcon
                config={{ type: 'custom', name: 'palaute', color: 'darkblue' }}
                style={{ marginRight: '5px', height: '15px' }}
              />
              {data.description}
            </div>
          )}
          <div className="ot-notification__description">
            {endDateTime}
            <FormattedMessage id={`${module_id}.body`} />
          </div>
          <Row>
              <OTButtonGroup expecedCount={2} fullWidth type="big" formulaButton collapseOnMobile>
                <OTButton
                  className="ot-notification__button"
                  onClick={() =>
                    WindowUtils.navigate('#/questionnaires' + data.link)
                  }
                >
                  <FormattedMessage id={`fill`} />
                </OTButton>
                <OTButton
                  onClick={() =>
                    doRequestDismissNotifications(
                      `${QUESTIONNAIRE_PAGE_NOTIFICATION}_${data.id}`
                    )
                  }
                >
                  <FormattedMessage id={`fill.later`} />
                </OTButton>
              </OTButtonGroup>
            {unitLogo}
          </Row>
        </Notification>
      );
    } else {
      if (appointmentData) {
        description = (
          <FormattedMessage
            id={`${module_id}.fill.questionnaire.with.appointment`}
            values={{
              name: data.name,
              department: getDepartmentDisplay(appointmentData.department),
              date: formatDate(appointmentData.date),
              time: formatTime(appointmentData.date),
              strong: (chunks) => <strong>{chunks}</strong>,
              strongSemibold: (chunks) => (
                <strong className="semibold">{chunks}</strong>
              ),
            }}
          />
        );
      } else {
        description = (
          <FormattedMessage
            id={`${module_id}.fill.questionnaire`}
            values={{ name: data.name }}
          />
        );
      }
    }
    //FINNGEN-TUTKIMUS / BIOPANKKI
    if (data.category === 'biopankki') {
      // Header
      headerMessage = <FormattedMessage id={`${module_id}.biobank.invite`} />;
      description = (
        <FormattedMessage
          id={`${module_id}.fill.name.only`}
          values={{ name: data.name }}
        />
      );
      info = (
        <FormattedMessage id={`${module_id}.biobank.info.questionnaire`} />
      );
      // Button texts
      otButtonTextNow = <FormattedMessage id={`show.more.info`} />;
      otButtonTextLater = <FormattedMessage id={`check.later`} />;
    }

    return (
      <Notification>
        <OTIcon
          config={{ type: 'custom', name: 'kyselyt', color: 'darkblue' }}
          style={{ width: '17px', marginRight: '20px' }}
        />
        <h2 className="ot-notification__header">{headerMessage}</h2>

        <div className="ot-notification__description">{description}</div>
        {data.description && (
          <div className="ot-notification__description">
            <OTIcon
              config={{ type: 'custom', name: 'palaute', color: 'darkblue' }}
              style={{ marginRight: '5px', height: '15px' }}
            />
            {data.description}
          </div>
        )}
        <div className="ot-notification__description">
          {endDateTime}
          <br />
          {info}
        </div>
        <Row>
            <OTButtonGroup expecedCount={2} fullWidth type="big" formulaButton collapseOnMobile>
              <OTButton
                className="ot-notification__button"
                onClick={() =>
                  WindowUtils.navigate('#/questionnaires' + data.link)
                }
              >
                {otButtonTextNow}
              </OTButton>
              <OTButton
                onClick={() =>
                  doRequestDismissNotifications(
                    `${QUESTIONNAIRE_PAGE_NOTIFICATION}_${data.id}`
                  )
                }
              >
                {otButtonTextLater}
              </OTButton>
            </OTButtonGroup>
          {unitLogo}
        </Row>
      </Notification>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    doRequestDismissNotifications: (notificationId) =>
      dispatch(doRequestDismissNotifications([notificationId])),
  };
};

export default connect(() => {}, mapDispatchToProps)(
  injectIntl(CareRequestNotification)
);
